import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-notification',
  templateUrl: './ui-notification.component.html',
  styleUrls: ['./ui-notification.component.scss']
})
export class UiNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
